export default __webpack_public_path__ + "static/media/cameraswitch.a3737e5d.png";